import React, { useState } from 'react';

/**
 * Copie avec repli gracieux - document 04.
 *
 * L'API presse-papiers est indisponible hors contexte sécurisé (file://, HTTP
 * en clair). Plutôt que d'échouer en silence, on bascule sur une zone de texte
 * présélectionnée que l'utilisateur copie lui-même : le parcours reste
 * praticable, ce qui est tout ce qui compte au moment de répondre à un client.
 */
export default function BoutonCopier({ texte, libelle = 'Copier la réponse' }) {
  const [etat, setEtat] = useState('pret'); // pret | copie | repli

  const copier = async () => {
    try {
      if (!navigator.clipboard) throw new Error('presse-papiers indisponible');
      await navigator.clipboard.writeText(texte);
      setEtat('copie');
      setTimeout(() => setEtat('pret'), 1800);
    } catch {
      setEtat('repli');
    }
  };

  return (
    <div>
      <button
        type="button"
        onClick={copier}
        style={{
          padding: 'var(--espace-2) var(--espace-4)',
          border: '1px solid var(--couleur-accent)',
          borderRadius: 'var(--rayon)',
          background: etat === 'copie' ? 'var(--couleur-succes)' : 'var(--couleur-accent)',
          color: 'var(--couleur-sur-accent)', fontWeight: 600,
        }}
      >
        {etat === 'copie' ? 'Copié' : libelle}
      </button>

      {etat === 'repli' && (
        <div style={{ marginTop: 'var(--espace-2)' }}>
          <p style={{ margin: '0 0 var(--espace-1)', fontSize: '0.8rem', color: 'var(--couleur-encre-douce)' }}>
            Le presse-papiers n’est pas accessible ici. Le texte est sélectionné, copiez-le.
          </p>
          <textarea
            readOnly
            value={texte}
            rows={4}
            className="champ"
            ref={(el) => el && el.select()}
          />
        </div>
      )}
    </div>
  );
}
